const profilePanelViews = [];

function checkUnsavedChanges() {
    return profilePanelViews.some(view => view.hasUnsavedChanges());
}

function watchUnsavedChanges(view) {
    profilePanelViews.push(view);
}

function unwatchUnsavedChanges(view) {
    const index = profilePanelViews.indexOf(view);
    if (index !== -1) {
        profilePanelViews.splice(index, 1);
    }
}

export { checkUnsavedChanges, watchUnsavedChanges, unwatchUnsavedChanges };
